const REDMATTER_LIST = 'https://redmatter.capital/xapi/rmswap/tokens/list';
const COMMON_LIST = 'https://redmatter.capital/static/rmswap/common.tokenlist.json';

// lower index == higher priority for token import
export const DEFAULT_LIST_OF_LISTS: string[] = [REDMATTER_LIST, COMMON_LIST];

// default lists to be 'active' aka searched across
export const DEFAULT_ACTIVE_LIST_URLS: string[] = [REDMATTER_LIST, COMMON_LIST];
